import React, { useEffect, useState } from 'react';

import { ManageStopControl } from '~/ui';

import { useButtonHandlers } from './useButtonHandlers';
import { useIsModalVisible } from './useIsModalVisible';
import DriverBreakModalMainView from '../Views/DriverBreakModalMain';
import ResequenceBreak from '../Views/ResequenceBreak';
import EditBreakDuration from '../Views/EditBreakDuration';

export const DriverBreakModal = () => {
    const { handleDelete, handleDeselect, handleEdit } = useButtonHandlers();
    const isModalVisible = useIsModalVisible();
    const [isEditingDuration, setIsEditingDuration] = useState(false);
    const [isResequencingBreak, setIsResequencingBreak] = useState(false);

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    useEffect(() => handleDeselect, []);

    useEffect(() => {
        if (isModalVisible) return;
        setIsEditingDuration(false);
        setIsResequencingBreak(false);
    }, [isModalVisible]);

    if (!isModalVisible) return null;

    return (
        <ManageStopControl
            className="driver-break-modal"
            data-testid="driver-break-modal"
        >
            {!isEditingDuration && !isResequencingBreak && (
                <DriverBreakModalMainView
                    handleDelete={handleDelete}
                    handleDeselect={handleDeselect}
                    setIsEditingDuration={setIsEditingDuration}
                    setIsResequencingBreak={setIsResequencingBreak}
                />
            )}

            {isResequencingBreak && (
                <ResequenceBreak
                    handleClose={() => setIsResequencingBreak(false)}
                />
            )}

            {isEditingDuration && (
                <EditBreakDuration
                    handleBack={() => setIsEditingDuration(false)}
                    handleClose={handleDeselect}
                    handleEditDuration={handleEdit}
                />
            )}
        </ManageStopControl>
    );
};
